import { loader } from 'graphql.macro'

export default function invoiceByUUIDQuery ({ dataLoaders, queryKey }) {
  const [, uuid] = queryKey

  const invoiceSchema = loader('./invoiceByUUID.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(invoiceSchema, { uuid })
}
